import ChecklistOutlinedIcon from '@mui/icons-material/ChecklistOutlined';

export const warehouseStockRepackingConfig = {
    all:  {
        title: 'all',
        icon: <ChecklistOutlinedIcon/>,
        isSingleDataGrid: true,
    },
};
